export const LISTADO_FILTROS_AL_REFRESCAR_DEFAULTS = "defaults";
export const LISTADO_FILTROS_AL_REFRESCAR_REQUEST =
  "listado_filtros_al_refrescar";

const normalizarModo = (valor) =>
  typeof valor === "string" ? valor.trim().toLowerCase() : "";

export const debeReiniciarFiltrosAlRefrescar = (opciones = {}) =>
  normalizarModo(opciones.listado_filtros_al_refrescar) ===
  LISTADO_FILTROS_AL_REFRESCAR_DEFAULTS;

export const prepararFiltrosParaRefrescar = ({
  opciones,
  filtroActivo = {},
  id,
}) => {
  const reiniciarFiltrosDefaults = debeReiniciarFiltrosAlRefrescar(opciones);

  return {
    reiniciarFiltrosDefaults,
    filtrosAAplicar: reiniciarFiltrosDefaults
      ? undefined
      : { ...filtroActivo, id },
  };
};

export const crearQueryFiltrosParaRequest = ({
  pantalla,
  reiniciarFiltrosDefaults,
  parametrosContexto = {},
  crearQuery,
}) =>
  reiniciarFiltrosDefaults
    ? { pantalla, ...parametrosContexto }
    : crearQuery();

export const agregarModoFiltrosAlBody = (
  body,
  reiniciarFiltrosDefaults,
  parametrosContexto = {}
) =>
  reiniciarFiltrosDefaults
    ? {
        ...body,
        ...parametrosContexto,
        [LISTADO_FILTROS_AL_REFRESCAR_REQUEST]:
          LISTADO_FILTROS_AL_REFRESCAR_DEFAULTS,
      }
    : body;
